import { FC } from 'react';

import { Icon, LinkButton } from '@eluve/components';

type OpenInReviewButtonProps = {
  appointmentId: string;
  tenantId: string;
};

export const OpenInReviewButton: FC<OpenInReviewButtonProps> = ({
  appointmentId,
  tenantId,
}) => {
  const url = `/review/appointments/${tenantId}/${appointmentId}`;

  return (
    <LinkButton variant="outline" to={url}>
      <Icon name="UserRoundSearch" size="auto" />
      Open in Review Dashboard
    </LinkButton>
  );
};
